import React, { useEffect, useState } from 'react';
import { Button, Card, Typography } from 'antd';
import { UserOutlined, KeyOutlined, ReloadOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';

import MobileUserApproval from './MobileUserApproval';
import MobileRoleAssign from './MobileRoleAssign';
import MobileRestartGateway from './MobileRestartGateway';

const { Title, Text } = Typography;

export default function MobilePermissionManagement() {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedKey, setSelectedKey] = useState('');

  useEffect(() => {
    try {
      const params = new URLSearchParams(location.search || '');
      const key = params.get('key') || '';
      setSelectedKey(key);
    } catch (e) {
      // ignore
    }
  }, [location.search]);

  const items = [
    {
      key: 'user-approval',
      title: '用户审批',
      icon: <UserOutlined />,
      description: '审批新注册用户登录权限',
    },
    {
      key: 'role-assign',
      title: '权限管理',
      icon: <KeyOutlined />,
      description: '管理员为用户分配角色',
    },
    {
      key: 'restart-gateway',
      title: '重启Gateway',
      icon: <ReloadOutlined />,
      description: '重启IB Gateway服务',
    },
  ];

  const handleCardClick = (key) => {
    navigate(`/permissions?key=${key}`, { replace: true });
  };

  if (selectedKey) {
    // 显示具体功能页面
    if (selectedKey === 'user-approval') {
      return <MobileUserApproval />;
    }
    if (selectedKey === 'role-assign') {
      return <MobileRoleAssign />;
    }
    if (selectedKey === 'restart-gateway') {
      return <MobileRestartGateway />;
    }

    // 默认返回网格视图
    return (
      <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', background: '#f5f5f5' }}>
        <div
          style={{
            position: 'sticky',
            top: 0,
            zIndex: 10,
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            padding: '16px 16px 12px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10 }}>
            <Title level={4} style={{ margin: 0, color: '#fff', fontWeight: 600 }}>
              权限管理
            </Title>
            <div style={{ display: 'flex', gap: 8 }}>
              <Button
                size="small"
                onClick={() => navigate('/permissions', { replace: true })}
                style={{
                  background: 'rgba(255,255,255,0.2)',
                  borderColor: 'rgba(255,255,255,0.3)',
                  color: '#fff',
                  backdropFilter: 'blur(10px)',
                }}
              >
                返回
              </Button>
              <Button
                size="small"
                onClick={() => navigate('/', { replace: true })}
                style={{
                  background: 'rgba(255,255,255,0.2)',
                  borderColor: 'rgba(255,255,255,0.3)',
                  color: '#fff',
                  backdropFilter: 'blur(10px)',
                }}
              >
                首页
              </Button>
            </div>
          </div>
        </div>

        <div style={{ flex: 1, overflow: 'auto', padding: '20px 16px 16px' }}>
          <Card style={{ borderRadius: 10 }} styles={{ body: { padding: 12 } }}>
            <Text type="secondary">未知功能页面，请返回重试。</Text>
          </Card>
        </div>
      </div>
    );
  }

  // 显示网格视图
  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', background: '#f5f5f5' }}>
      <div
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 10,
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          padding: '16px 16px 12px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10 }}>
          <Title level={4} style={{ margin: 0, color: '#fff', fontWeight: 600 }}>
            权限管理
          </Title>
          <div style={{ display: 'flex', gap: 8 }}>
            <Button
              size="small"
              onClick={() => navigate('/', { replace: true })}
              style={{
                background: 'rgba(255,255,255,0.2)',
                borderColor: 'rgba(255,255,255,0.3)',
                color: '#fff',
                backdropFilter: 'blur(10px)',
              }}
            >
              首页
            </Button>
          </div>
        </div>
      </div>

      <div style={{ flex: 1, overflow: 'auto', padding: '20px 16px 16px' }}>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
            gap: 12,
            marginTop: 16,
          }}
        >
          {items.map((item) => (
            <Card key={item.key} hoverable onClick={() => handleCardClick(item.key)} style={{ borderRadius: 10, cursor: 'pointer' }} styles={{ body: { padding: 16, textAlign: 'center' } }}>
              <div style={{ fontSize: 32, color: '#1677ff', marginBottom: 12 }}>{item.icon}</div>
              <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 8 }}>{item.title}</div>
              <div style={{ color: '#666', fontSize: 12, lineHeight: 1.4 }}>{item.description}</div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}
